export const REPLENISHMENT_TYPES = {
	NORMAL: 'Normal',
	ONE_BEAT: 'OneBeat',
	SYNC_FLOW: 'SyncFlow',
	BOTH: 'Ambos'
} as const

export interface FiltersSurtidoTiendas {
	Base: string
	Segmentos: string[]
	FechaVenta: Date
	Plaza: number
	Tiendas: string[]
	FechaConta: Date
	FechaDoc: Date
	ListaPrecios: number
	Comentario: string
	UserSAP: string
	PwdSAP: string
	penetracionBuffer: boolean
}

export interface ResultExec {
	status: number
	mensaje?: string
}

export interface DataDetalleSurtidoTienda {
	Centro: string
	Vta: string
	Orders: number
	ItemCode: string
	ItemName: string
	WhsCode: string
	AlmPuenteVal: string
	WhsName: string
	WhsFrom: string
	SalesDays: number
	UGspItorder: number
	VtaAcumulada: number
	MinOrder: number
	MinStock: number
	WhsOnHand: number
	WhsOnHandTransito: number
	WhsFromOnHand: number
	UUBysRotacion: number
	RotaReal: number
	Buffer: number
	TipoRep: string
	EstatusArt: string
	UBysAlmPuente: string | null
	WhsOnHandPuente: number
	Day7Qty: number
	Day6Qty: number
	Day5Qty: number
	Day4Qty: number
	Day3Qty: number
	Day2Qty: number
	Day1Qty: number
	Surtir: boolean
	Cantidad: number
	Reponer: string | number
	Entregado: string | number
	Negado: string | number
	SalesSum: number
	SalesAvg: number
	RotaCalc: number
	TipoArticulo: string
	ID: string | null
	PenetracionBuffer: number
	Hsbt: string
	HsbtSegmento: string
	HsbtGlobal: string
	AplicaSurtidoExtra?: string
}

export interface ParameterSGI {
	Value: string | number
}

export interface LogResultDocument {
	WhsCodeFrom: string
	AlmPuenteVal?: string
	WhsCode: string
	DocNum?: number
	SolDocNum?: number
	Error?: string
}

export interface ResultDocument {
	DocNum: number
	Error?: string
}

export type WhsBufferPercentConfiguration = {
	almacen: string
	linea: number
	moda: number
	accesorios: number
	otros: number
}

export interface SurtidoTiendasSliceTypes extends FiltersSurtidoTiendas {
	data: DataDetalleSurtidoTienda[]
	step: number
	logDocs: LogResultDocument[]
	whsBufferPercents?: WhsBufferPercentConfiguration[]
}

export type SurtidoTiendasPayloadAction = Omit<SurtidoTiendasSliceTypes, 'penetracionBuffer'>

export interface ItemStock {
	ItemCode: string
	WhsFrom: string
	WhsFromOnHand: number
}

export interface DocsPendientes {
	WhsFrom: string
	WhsPuente: string
	WhsCode: string
	BaseCode: string
	Fecha: string
	DocNumTransfer: number
	DocEntryTransfer: number
}

export interface ISesionSAP {
	User: string
	Pwd: string
}

export interface Tienda {
	almacen: string
	descripcion: string
	prioridad: number
	surtir: boolean
}

export interface ConfigDiasSurtido {
	Location: number
	Plaza: string
	Almacen: string
	Descripcion: string
	Maximizador: number
	Lunes: string
	Martes: string
	Miercoles: string
	Jueves: string
	Viernes: string
	Sabado: string
	Domingo: string
	PorcLinea: number
	PorcModa: number
	PorcAccesorios: number
	PorcOtros: number
	MasLunes: string
	MasMartes: string
	MasMiercoles: string
	MasJueves: string
	MasViernes: string
	MasSabado: string
	MasDomingo: string
}

export type ConfigDiasSurtidoValues = {
	Lunes: boolean
	Martes: boolean
	Miercoles: boolean
	Jueves: boolean
	Viernes: boolean
	Sabado: boolean
	Domingo: boolean
	PorcLinea: number
	PorcModa: number
	PorcAccesorios: number
	PorcOtros: number
}

export interface PropsConfigDiasSurtido {
	data: ConfigDiasSurtido
	onChangeConfig: (data: ConfigDiasSurtido) => void
}

export interface IPlaza {
	code: number
	name: string
}

export interface SurtidoTiendaLog {
	Location: number
	Plaza: string
	AlmOrigen: string
	AlmDestino: string
	Puente: string
	FechaContabilidad: string
	FechaDocumento: string
	TransferDocNum: number
	SolTrasladoDocNum: number
	Fecha: string
	Hora: string
}

export interface XlsxMinFile {
	whscode: string
	itemcode: string
	valor: number
	finicio: string
	ffin: string
}

export type MaximumRequest = Omit<XlsxMinFile, 'valor'> & {
	maximo: number
}

export type MinimumRequest = Omit<XlsxMinFile, 'valor'> & {
	minimo: number
}
